import { INTERNALFlag, useINTERNALFlag, PropsNoName } from '@components/Flag';
/** [ME-156346](https://masterysys.atlassian.net/browse/ME-156346) Enables to view the county field on address */
export const useFlagMe156346ViewAddressCounty = (): boolean => useINTERNALFlag('ME-156346-view-address-county');
/** [ME-156346](https://masterysys.atlassian.net/browse/ME-156346) Enables to view the county field on address */
export const FlagMe156346ViewAddressCounty = (props: PropsNoName) => <INTERNALFlag name="ME-156346-view-address-county" {...props}/>
